import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";

// Bouton de contact direct, visible sur tout le site, uniquement si un
// numero a ete renseigne et le canal active dans Atlas > Reglages avances.
export default function WhatsAppFlottant() {
  const [config, setConfig] = useState({ actif: false });
  useEffect(() => { http.get("/contact/whatsapp").then((r) => setConfig(r.data)).catch(() => {}); }, []);
  if (!config.actif) return null;
  const numero = config.numero.replace(/[^0-9]/g, "");
  return (
    <a
      href={`https://wa.me/${numero}?text=${encodeURIComponent("Bonjour, je vous contacte depuis AfriFuté Atlas.")}`}
      target="_blank" rel="noreferrer" data-testid="whatsapp-flottant"
      style={{
        position: "fixed", bottom: 22, right: 22, width: 54, height: 54, borderRadius: "50%",
        background: "#25D366", display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 6px 18px rgba(0,0,0,.22)", zIndex: 60, transition: "transform .15s",
      }}
      onMouseDown={(e) => { e.currentTarget.style.transform = "scale(.92)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
      aria-label="Nous contacter sur WhatsApp"
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="#fff"><path d="M12 2a10 10 0 00-8.6 15l-1.3 4.8 4.9-1.3A10 10 0 1012 2zm0 2a8 8 0 11-4.1 14.9l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 0112 4zm4.5 9.6c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1l-.7.9c-.1.2-.3.2-.5.1a6.5 6.5 0 01-3.2-2.8c-.2-.4.2-.4.6-1.2.1-.1 0-.3 0-.4l-.7-1.7c-.2-.5-.4-.4-.5-.4h-.5c-.2 0-.4.1-.6.3-.7.7-.9 1.6-.6 2.8.5 1.6 1.6 3 3.2 4 2.2 1.3 3.1 1 3.7.9.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1z"/></svg>
    </a>
  );
}
